import { AxiosError } from 'axios';

type ErrorBody = Record<string, unknown> & {
  error?: unknown;
  detail?: unknown;
};

export function apiError(error: unknown, fallback: string): string {
  if (!(error instanceof AxiosError)) return fallback;
  const data = error.response?.data as ErrorBody | string | undefined;
  if (!data || typeof data === 'string') return fallback;
  if (typeof data.error === 'string' && data.error) return data.error;
  if (typeof data.detail === 'string' && data.detail) return data.detail;
  for (const value of Object.values(data)) {
    if (Array.isArray(value) && value.length && typeof value[0] === 'string') {
      return value.join(' ');
    }
  }
  return fallback;
}
